module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step01-823d937dc6b2303a8770c0d8f461760c.jpg";